import { getEnvValue } from '@/services/env-service.js'
const API_URL = getEnvValue(
  'VITE_GEONLINE_NEWS_API_HOST_URL',
  'http://geonline-news-api.simpliciti-frontend.geored.fr'
)
export async function getNews(filters) {
  return await window.fetch(API_URL + '/api/news').then((r) => r.json())
}

export default {
  getNews,
}
